// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1657":"3f6b285f2d29d663","8947":"eb74fd70f8d95634","9175":"0abfd098412d0024"}[chunkId] + ".js";
};